import React from "react";
import popoverReviewImage from "../../../../images/new-images/review.png";
import ideaBulb from "../../../../images/new-images/Idea-Bulb.png";
import "../begin-questionnaire/begin-questionnaire.css";

const RenderReviewPopOver = (props) => {
  return (
    <div className="review-popover-contents">
      <div className="review-popover-content-wrapper">
        <h1 className="popover-heading">Review Assessment</h1>
        <img src={popoverReviewImage} alt="popoverReviewImage" />
        <ul>
          <li>
            <img src={ideaBulb} alt="ideaBulb" />
            <p>
              You can click on the question number directly to review your
              response.
            </p>
          </li>
          <li>
            <img src={ideaBulb} alt="ideaBulb" />
            <p>
              You can click on Save & Continue to proceed to the next question.
            </p>
          </li>
          <li>
            <img src={ideaBulb} alt="ideaBulb" />
            <p>You can choose to Submit directly from any question.</p>
          </li>
        </ul>
        <button onClick={props.handleCloseReviewPopOver}>Got It</button>
      </div>
    </div>
  );
};
export default RenderReviewPopOver;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/reviewPopOver.jsx